import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Form, Button, Container } from 'react-bootstrap';
import logo from '../../assets/images/bombiix-logo.svg';
import './styles.css';
import { forgetPassword } from '../Auth/store/Auth.action';
import Loader from '../../Components/Utility/Loader/Loader';

function ForgotPW() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const history = useHistory();
  const [pageLoader, setPageLoader] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = async (data) => {
    const params = {
      email: data?.email,
    };
    setPageLoader(true);
    const resdata = await dispatch(forgetPassword(params, t));
    if (resdata) {
      return history.push('/login');
    }
    setPageLoader(false);
    return null;
  };

  return (
    <div>
      {pageLoader ? (
        <Loader />
      ) : (
        <Container>
          <div className="login-container-bombiix">
            <div className="logo-container">
              <img src={logo} className="img-fluid logo logo-size" alt="logo" />
            </div>
            <div className="mt-40">
              <Form className="login-form" onSubmit={handleSubmit(onSubmit)}>
                <Form.Group controlId="formBasicEmail">
                  <Form.Label>{t('FORGOT_PASSWORD.FORGOT_YOUR_PASSWORD')}</Form.Label>
                  <Form.Control
                    {...register('email', {
                      required: t('FORGOT_PASSWORD.EMAIL_REQUIRED'),
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: t('FORGOT_PASSWORD.ENTER_VALID_EMAIL'),
                      },
                    })}
                    placeholder={t('FORGOT_PASSWORD.ENTER_EMAIL')}
                    className={watch('email') && 'data-filled'}
                  />

                  {errors?.email?.message && <div className="text-danger">{errors?.email?.message}</div>}
                </Form.Group>
                <div className="d-flex align-items-center justify-content-center">
                  <Link className="btn-white text-decoration-none" to="/login">
                    {t('FORGOT_PASSWORD.BACK')}
                  </Link>
                  <Button variant="primary" className="btn-theme ml-16" type="submit">
                    {t('FORGOT_PASSWORD.SUBMIT')}
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Container>
      )}
    </div>
  );
}

export default ForgotPW;
